//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
let d=[[[1,"BackoffAngle",0,"CAM.InheritableDoubleBuilder",0],[1,"BackoffDistance",0,"CAM.InheritableToolDepBuilder",0],[0,"BladeEdgePoint",1,0],[0,"EdgeDefinition",1,0],[1,"ExtendRadialDistance",0,"CAM.InheritableToolDepBuilder",0],[1,"ExtendTangentialDistance",0,"CAM.InheritableToolDepBuilder",0]],[],[]];
SPLM.CAM.BladeEdge = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BladeEdge";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.BladeEdge.EdgeDefinitionType = Object.freeze({
    "Inherit" : "Inherit", "Specify" : "Specify"});

SPLM.CAM.BladeEdge.EdgePointType = Object.freeze({
    "AlongBladeDirection" : "AlongBladeDirection", "AlongPartAxis" : "AlongPartAxis", "NoCurling" : "NoCurling"});

export default SPLM;